import { render, staticRenderFns } from "./risk-disclosure.vue?vue&type=template&id=77881a6b&scoped=true&"
import script from "./risk-disclosure.vue?vue&type=script&lang=js&"
export * from "./risk-disclosure.vue?vue&type=script&lang=js&"
import style0 from "./risk-disclosure.vue?vue&type=style&index=0&id=77881a6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77881a6b",
  null
  
)

component.options.__file = "risk-disclosure.vue"
export default component.exports